/* eslint-disable no-lonely-if */
import React, {Component} from 'react';
import {CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe} from 'react-stripe-elements';
import AuthService from './AuthService';
import constants from '../config';

const Auth = new AuthService();

var US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
  'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
  'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY',
  'DC','PR','VI','GU','AS','MP',
];

var BRAND_ICONS = {
  visa: 'fa-cc-visa',
  mastercard: 'fa-cc-mastercard',
  amex: 'fa-cc-amex',
  discover: 'fa-cc-discover',
  diners: 'fa-cc-diners-club',
  jcb: 'fa-cc-jcb',
};

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethod: 'card',
      sameAddress: true,
      clickedBuy: 0,
      error: '',
      // Shipping / shared fields
      shippingTo: '',
      guestEmail: '',
      street1: '',
      street2: '',
      city: '',
      addrState: '',
      zip: '',
      country: 'US',
      // Separate billing fields
      billingStreet1: '',
      billingStreet2: '',
      billingCity: '',
      billingState: '',
      billingZip: '',
      billingCountry: 'US',
      savedAddresses: [],
      selectedAddressId: null,
      // Saved cards
      savedCards: [],
      selectedCardId: null, // null = new card, string = saved card id
      saveNewCard: false,
      loadingCards: true,
      taxRate: 0,
      taxLoading: false,
    };
    this.submit = this.submit.bind(this);
    this._expiryEl = null;
    this._cvcEl = null;
  }

  get shippingValid() {
    var s = this.state;
    var isLoggedIn = !!Auth.getToken();
    return isLoggedIn
      ? !!(s.shippingTo && s.street1 && s.city && s.addrState && s.zip && s.country)
      : !!(s.guestEmail && s.shippingTo && s.street1 && s.city && s.addrState && s.zip && s.country);
  }

  shippingValidFromState(s) {
    var isLoggedIn = !!Auth.getToken();
    return isLoggedIn
      ? !!(s.shippingTo && s.street1 && s.city && s.addrState && s.zip && s.country)
      : !!(s.guestEmail && s.shippingTo && s.street1 && s.city && s.addrState && s.zip && s.country);
  }

  componentDidUpdate(prevProps, prevState) {
    var wasValid = this.shippingValidFromState(prevState);
    var isValid = this.shippingValid;
    if (wasValid !== isValid && this.props.onShippingValidChange) {
      this.props.onShippingValidChange(isValid);
    }
  }

  componentDidMount() {
    // Auto-fill address and name from saved addresses if logged in
    if (Auth.getToken()) {
      var self = this;
      try {
        var profile = Auth.getProfile();
        if (profile && profile._id) {
          var addressesPromise = Auth.fetch(constants.DOMAIN + '/api/v1/users/addresses', {
            mode: 'cors',
            method: 'GET',
          }).catch(function() { return { addresses: [] }; });
          var profilePromise = Auth.fetch(constants.DOMAIN + '/api/v1/users/' + profile._id, {
            mode: 'cors',
            method: 'GET',
          }).catch(function() { return { profile: {} }; });
          var cardsPromise = Auth.fetch(constants.DOMAIN + '/api/v1/transactions/payment-methods', {
            mode: 'cors',
            method: 'GET',
          }).catch(function() { return { cards: [] }; });
          Promise.all([addressesPromise, profilePromise, cardsPromise]).then(function(results) {
            var addresses = (results[0] && results[0].addresses) || [];
            var fullName = (results[1] && results[1].profile && results[1].profile.name) || '';
            var cards = (results[2] && results[2].cards) || [];
            self.setState({ savedAddresses: addresses, savedCards: cards, loadingCards: false });
            // Auto-select default card if available
            if (cards.length > 0) {
              var defaultCard = cards.find(function(c) { return c.isDefault; });
              self.setState({ selectedCardId: defaultCard ? defaultCard.id : cards[0].id });
            }
            if (fullName) {
              self.setState({ shippingTo: fullName });
            }
            var defaultAddr = addresses.find(function(a) { return a.isDefault; });
            if (defaultAddr) {
              self.applyAddress(defaultAddr);
            } else if (addresses.length > 0) {
              self.applyAddress(addresses[0]);
            }
          });
        }
      } catch (e) { self.setState({ loadingCards: false }); }
    } else {
      this.setState({ loadingCards: false });
    }
  }

  applyAddress(addr) {
    var update = { selectedAddressId: addr._id };
    if (addr.street1) update.street1 = addr.street1;
    update.street2 = addr.street2 || '';
    if (addr.city) update.city = addr.city;
    if (addr.state) update.addrState = addr.state;
    if (addr.zip) update.zip = addr.zip;
    if (addr.country) update.country = addr.country;
    this.setState(update);
    if (addr.zip && addr.state) {
      this.fetchTaxRate(addr.zip, addr.state);
    }
  }

  fetchTaxRate(zip, state) {
    var self = this;
    var cleanZip = (zip || '').trim();
    var cleanState = (state || '').trim();
    if (cleanZip.length !== 5 || !cleanState) {
      self.setState({ taxRate: 0, taxLoading: false });
      if (self.props.onTaxChange) self.props.onTaxChange(0, false, cleanZip, cleanState);
      return;
    }
    self.setState({ taxLoading: true });
    if (self.props.onTaxChange) self.props.onTaxChange(0, true, cleanZip, cleanState);
    fetch(constants.DOMAIN + '/api/v1/guest/tax-rate?zip=' + encodeURIComponent(cleanZip) + '&state=' + encodeURIComponent(cleanState))
      .then(function(resp) { return resp.json(); })
      .then(function(data) {
        var rate = data.rate || 0;
        self.setState({ taxRate: rate, taxLoading: false });
        if (self.props.onTaxChange) self.props.onTaxChange(rate, false, cleanZip, cleanState);
      })
      .catch(function() {
        self.setState({ taxRate: 0, taxLoading: false });
        if (self.props.onTaxChange) self.props.onTaxChange(0, false, cleanZip, cleanState);
      });
  }

  debouncedFetchTaxRate(zip, state) {
    var self = this;
    if (self._taxDebounce) clearTimeout(self._taxDebounce);
    self._taxDebounce = setTimeout(function() {
      self.fetchTaxRate(zip, state);
    }, 300);
  }

  submit(ev) {
    ev.preventDefault();
    var s = this.state;

    // PayPal is handled by the injected PayPal button — the form submit only does Stripe
    if (s.paymentMethod === 'paypal') return;

    if (s.sameAddress) {
      // Billing = Shipping
      var data = new URLSearchParams();
      if (s.shippingTo) data.append('shippingTo', s.shippingTo);
      if (s.street1) {
        data.append('shippingStreet1', s.street1);
        data.append('billingStreet1', s.street1);
      }
      data.append('shippingStreet2', s.street2 || ' ');
      data.append('billingStreet2', s.street2 || ' ');
      if (s.city) {
        data.append('shippingCity', s.city);
        data.append('billingCity', s.city);
      }
      if (s.addrState) {
        data.append('shippingState', s.addrState);
        data.append('billingState', s.addrState);
      }
      if (s.zip) {
        data.append('shippingZip', s.zip);
        data.append('billingZip', s.zip);
      }
      if (s.country) {
        data.append('shippingCountry', s.country);
        data.append('billingCountry', s.country);
      }
      if (!Auth.getToken()) {
        if (s.guestEmail) data.append('guestEmail', s.guestEmail);
        data.append('guestName', s.shippingTo || '');
      }

      var requiredFilled = Auth.getToken()
        ? (s.shippingTo && s.street1 && s.city && s.addrState && s.zip && s.country)
        : (s.guestEmail && s.shippingTo && s.street1 && s.city && s.addrState && s.zip && s.country);

      if (!requiredFilled) {
        this.setState({ error: 'Please fill in all required fields.' });
        return;
      }
      if (this.props.trackingUpgrade) data.append('trackingUpgrade', 'true');
      this.setState({ error: '' });

      // Use saved card or new card
      if (s.selectedCardId && Auth.getToken()) {
        this._processSavedCardPayment(data);
      } else {
        this._processStripePayment(data);
      }
    } else {
      // Separate billing/shipping
      var data2 = new URLSearchParams();
      if (s.shippingTo) data2.append('shippingTo', s.shippingTo);
      if (s.street1) data2.append('shippingStreet1', s.street1);
      if (s.billingStreet1) data2.append('billingStreet1', s.billingStreet1);
      if (s.street2) data2.append('shippingStreet2', s.street2);
      if (s.billingStreet2) data2.append('billingStreet2', s.billingStreet2);
      if (s.city) data2.append('shippingCity', s.city);
      if (s.billingCity) data2.append('billingCity', s.billingCity);
      if (s.addrState) data2.append('shippingState', s.addrState);
      if (s.billingState) data2.append('billingState', s.billingState);
      if (s.zip) data2.append('shippingZip', s.zip);
      if (s.billingZip) data2.append('billingZip', s.billingZip);
      if (s.country) data2.append('shippingCountry', s.country);
      if (s.billingCountry) data2.append('billingCountry', s.billingCountry);
      if (!Auth.getToken()) {
        if (s.guestEmail) data2.append('guestEmail', s.guestEmail);
        data2.append('guestName', s.shippingTo || '');
      }

      var reqFilled2 = Auth.getToken()
        ? (s.shippingTo && s.street1 && s.billingStreet1 && s.city && s.billingCity && s.addrState && s.billingState && s.zip && s.billingZip && s.country && s.billingCountry)
        : (s.guestEmail && s.shippingTo && s.street1 && s.billingStreet1 && s.city && s.billingCity && s.addrState && s.billingState && s.zip && s.billingZip && s.country && s.billingCountry);

      if (!reqFilled2) {
        this.setState({ error: 'Please fill in all required fields.' });
        return;
      }
      if (this.props.trackingUpgrade) data2.append('trackingUpgrade', 'true');
      this.setState({ error: '' });

      if (s.selectedCardId && Auth.getToken()) {
        this._processSavedCardPayment(data2);
      } else {
        this._processStripePayment(data2);
      }
    }
  }

  _processSavedCardPayment(data) {
    var self = this;
    this.props.processPayment();

    self.setState({ clickedBuy: self.state.clickedBuy + 1 }, function() {
      if (self.state.clickedBuy !== 1) {
        self.setState({ error: 'Processing payment...' });
        return;
      }

      // Determine endpoint — saved card uses customerbuy (GET)
      var endpoint;
      if (self.props.shareId) {
        endpoint = constants.DOMAIN + '/api/v1/transactions/' + self.props.shareId + '/customermetabuy';
      } else {
        endpoint = constants.DOMAIN + '/api/v1/transactions/' + self.props.productId + '/customerbuy';
      }
      // Append tracking upgrade
      if (self.props.trackingUpgrade) {
        endpoint += (endpoint.indexOf('?') !== -1 ? '&' : '?') + 'trackingUpgrade=true';
      }
      // Append offerId query param for offer-price purchases
      if (self.props.offerId) {
        endpoint += (endpoint.indexOf('?') !== -1 ? '&' : '?') + 'offerId=' + self.props.offerId;
      }

      Auth.fetch(endpoint, {
        mode: 'cors',
        method: 'GET',
      }).then(function(res) {
        if (res && res.success) {
          self.props.paymentComplete();
        } else {
          if (self.props.resetLoading) self.props.resetLoading();
          self.setState({ submitting: false, clickedBuy: 0, error: (res && res.error) || 'Payment failed. Please try again.' });
        }
      }).catch(function(err) {
        console.log(err);
        if (self.props.resetLoading) self.props.resetLoading();
        self.setState({ submitting: false, clickedBuy: 0, error: 'Payment failed. Please try again.' });
      });
    });
  }

  _processStripePayment(data) {
    var self = this;
    this.props.processPayment();

    if (!this.props.stripe) {
      this.setState({ error: "Payment system not loaded. Please refresh and try again." });
      return;
    }

    this.props.stripe.createToken().then(function(payload) {
      if (payload.error) {
        if (self.props.resetLoading) self.props.resetLoading();
        self.setState({ error: payload.error.message });
        return;
      }
      self.setState({ clickedBuy: self.state.clickedBuy + 1 }, function() {
        if (self.state.clickedBuy !== 1) {
          self.setState({ error: 'Processing payment...' });
          return;
        }
        data.append('token', payload.token.id);

        // Determine endpoint
        var endpoint;
        if (self.props.shareId) {
          endpoint = Auth.getToken()
            ? constants.DOMAIN + '/api/v1/transactions/' + self.props.shareId + '/metabuy'
            : constants.DOMAIN + '/api/v1/transactions/' + self.props.shareId + '/metaguestbuy';
        } else {
          endpoint = Auth.getToken()
            ? constants.DOMAIN + '/api/v1/transactions/' + self.props.productId + '/buy'
            : constants.DOMAIN + '/api/v1/transactions/' + self.props.productId + '/guestbuy';
        }
        // Append offerId query param for offer-price purchases
        if (self.props.offerId) {
          endpoint += (endpoint.indexOf('?') !== -1 ? '&' : '?') + 'offerId=' + self.props.offerId;
        }

        Auth.fetch(endpoint, {
          mode: 'cors',
          method: 'POST',
          body: data,
        }).then(function(res) {
          if (res && res.success) {
            // Save card if checkbox was checked
            if (self.state.saveNewCard && res.chargeId) {
              Auth.fetch(constants.DOMAIN + '/api/v1/transactions/payment-methods/save-from-charge', {
                mode: 'cors',
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ chargeId: res.chargeId }),
              }).catch(function() {});
            }
            self.props.paymentComplete();
          } else {
            if (self.props.resetLoading) self.props.resetLoading();
            self.setState({ submitting: false, clickedBuy: 0, error: (res && res.error) || 'Payment failed. Please try again.' });
          }
        }).catch(function(err) {
          console.log(err);
          if (self.props.resetLoading) self.props.resetLoading();
          self.setState({ submitting: false, clickedBuy: 0, error: 'Payment failed. Please try again.' });
        });
      });
    });
  }

  render() {
    var self = this;
    var s = this.state;
    var isLoggedIn = !!Auth.getToken();
    var hasPaypal = true; // PayPal always available — platform collects all payments
    var trackingFee = this.props.trackingUpgrade ? (constants.TRACKING_UPGRADE_FEE || 5.50) : 0;
    var FLAT_SHIPPING_FEE = constants.FLAT_SHIPPING_FEE || 1.00;
    var FREE_SHIPPING_THRESHOLD = constants.FREE_SHIPPING_THRESHOLD || 10;
    var computedShipping = Number(this.props.price) >= FREE_SHIPPING_THRESHOLD ? 0 : FLAT_SHIPPING_FEE;
    var TRANSACTION_FEE = constants.TRANSACTION_FEE || 0.50;
    var taxAmount = Math.round(Number(this.props.price) * s.taxRate * 100) / 100;
    var total = (Number(this.props.price) + computedShipping + trackingFee + TRANSACTION_FEE + taxAmount).toFixed(2);
    var usingSavedCard = !!s.selectedCardId && isLoggedIn;

    var inputClass = 'tw-w-full tw-px-4 tw-py-2.5 tw-text-sm tw-rounded-lg tw-border tw-border-[#e5e5e5] dark:tw-border-[#2a2a2a] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white tw-outline-none focus:tw-border-brand-gold';
    var selectClass = inputClass + ' tw-appearance-none';
    var checkSvg = "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='%2322c55e' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z' clip-rule='evenodd'/%3E%3C/svg%3E\")";
    var validBorder = '#22c55e';
    var isNameValid = s.shippingTo.trim().length > 0;
    var isEmailValid = !isLoggedIn ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.guestEmail.trim()) : true;
    var isStreet1Valid = s.street1.trim().length > 0;
    var isCityValid = s.city.trim().length > 0;
    var isStateValid = s.addrState !== '';
    var isZipValid = /^\d{5}$/.test(s.zip.trim());
    var isBillingStreet1Valid = (s.billingStreet1 || '').trim().length > 0;
    var isBillingCityValid = (s.billingCity || '').trim().length > 0;
    var isBillingStateValid = (s.billingState || '') !== '';
    var isBillingZipValid = /^\d{5}$/.test((s.billingZip || '').trim());
    function validStyle(isValid, extra) {
      if (!isValid) return extra || undefined;
      var vs = { borderColor: validBorder, paddingRight: '36px', backgroundImage: checkSvg, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 10px center', backgroundSize: '16px' };
      return extra ? Object.assign({}, extra, vs) : vs;
    }

    var stateDropdown = function(value, onChange, isValid) {
      return (
        <div className="tw-relative" style={{ width: '120px' }}>
          <select value={value} onChange={onChange} className={selectClass} style={{ paddingRight: '28px', borderColor: isValid ? validBorder : undefined }}>
            <option value="">State</option>
            {US_STATES.map(function(st) { return <option key={st} value={st}>{st}</option>; })}
          </select>
          <i className="fa fa-chevron-down tw-absolute tw-right-3 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-text-[10px] tw-text-[#999] tw-pointer-events-none" />
        </div>
      );
    };

    // Shared address fields (shipping, or both when sameAddress)
    var addressFields = (
      <div className="tw-flex tw-flex-col tw-gap-3">
        <input type="text" placeholder="Street address" value={s.street1}
          onChange={function(e) { self.setState({ street1: e.target.value }); }}
          className={inputClass} style={validStyle(isStreet1Valid)} />
        <input type="text" placeholder="Street address 2 (optional)" value={s.street2}
          onChange={function(e) { self.setState({ street2: e.target.value }); }}
          className={inputClass} />
        <div className="tw-flex tw-gap-3">
          <input type="text" placeholder="City" value={s.city}
            onChange={function(e) { self.setState({ city: e.target.value }); }}
            className={inputClass + ' tw-flex-1'} style={validStyle(isCityValid)} />
          {stateDropdown(s.addrState, function(e) { self.setState({ addrState: e.target.value }); self.debouncedFetchTaxRate(s.zip, e.target.value); }, isStateValid)}
        </div>
        <div className="tw-flex tw-gap-3">
          <input type="text" placeholder="ZIP code" value={s.zip}
            onChange={function(e) { self.setState({ zip: e.target.value }); self.debouncedFetchTaxRate(e.target.value, s.addrState); }}
            className={inputClass} style={validStyle(isZipValid, { width: '120px' })} />
          {/* USA-only: country locked to US. Uncomment below to allow international */}
          {/* <input type="text" placeholder="Country" value={s.country}
            onChange={function(e) { self.setState({ country: e.target.value }); }}
            className={inputClass + ' tw-flex-1'} /> */}
          <input type="text" value="US" readOnly className={inputClass + ' tw-flex-1 tw-opacity-60 tw-cursor-not-allowed'} />
        </div>
      </div>
    );

    var billingFields = !s.sameAddress ? (
      <div className="tw-mt-4">
        <h2 className="tw-text-base tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-3">Billing Address</h2>
        <div className="tw-flex tw-flex-col tw-gap-3">
          <input type="text" placeholder="Street address" value={s.billingStreet1}
            onChange={function(e) { self.setState({ billingStreet1: e.target.value }); }}
            className={inputClass} style={validStyle(isBillingStreet1Valid)} />
          <input type="text" placeholder="Street address 2 (optional)" value={s.billingStreet2}
            onChange={function(e) { self.setState({ billingStreet2: e.target.value }); }}
            className={inputClass} />
          <div className="tw-flex tw-gap-3">
            <input type="text" placeholder="City" value={s.billingCity}
              onChange={function(e) { self.setState({ billingCity: e.target.value }); }}
              className={inputClass + ' tw-flex-1'} style={validStyle(isBillingCityValid)} />
            {stateDropdown(s.billingState, function(e) { self.setState({ billingState: e.target.value }); }, isBillingStateValid)}
          </div>
          <div className="tw-flex tw-gap-3">
            <input type="text" placeholder="ZIP code" value={s.billingZip}
              onChange={function(e) { self.setState({ billingZip: e.target.value }); }}
              className={inputClass} style={validStyle(isBillingZipValid, { width: '120px' })} />
            {/* USA-only: country locked to US. Uncomment below to allow international */}
            {/* <input type="text" placeholder="Country" value={s.billingCountry}
              onChange={function(e) { self.setState({ billingCountry: e.target.value }); }}
              className={inputClass + ' tw-flex-1'} /> */}
            <input type="text" value="US" readOnly className={inputClass + ' tw-flex-1 tw-opacity-60 tw-cursor-not-allowed'} />
          </div>
        </div>
      </div>
    ) : null;

    var isDark = document.documentElement.classList.contains('tw-dark');

    return (
      <form onSubmit={this.submit}>
        <style>{
          isDark ? `
            input:-webkit-autofill,
            input:-webkit-autofill:hover,
            input:-webkit-autofill:focus,
            select:-webkit-autofill,
            select:-webkit-autofill:hover,
            select:-webkit-autofill:focus {
              -webkit-box-shadow: 0 0 0 1000px #141414 inset !important;
              -webkit-text-fill-color: #ffffff !important;
              border-color: #555 !important;
              transition: background-color 5000s ease-in-out 0s;
            }
          ` : ''
        }</style>
        {/* Shipping Address */}
        <div className="tw-mb-6">
          <h2 className="tw-text-base tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-4">Shipping Address</h2>
          {/* Saved address selector */}
          {s.savedAddresses.length > 0 && (
            <div className="tw-flex tw-flex-wrap tw-gap-2 tw-mb-4">
              {s.savedAddresses.map(function(addr) {
                var isSelected = s.selectedAddressId === addr._id;
                return (
                  <button
                    key={addr._id}
                    type="button"
                    onClick={function() { self.applyAddress(addr); }}
                    className={'tw-text-left tw-px-3 tw-py-2 tw-rounded-lg tw-text-xs tw-cursor-pointer tw-transition-colors tw-border ' + (
                      isSelected
                        ? 'tw-border-brand-gold tw-bg-brand-gold/10'
                        : 'tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-white dark:tw-bg-[#141414] hover:tw-border-brand-gold/50'
                    )}
                  >
                    <span className={'tw-font-semibold tw-block ' + (isSelected ? 'tw-text-brand-gold' : 'tw-text-[#1a1a1a] dark:tw-text-white')}>
                      {addr.label}{addr.isDefault ? ' (Default)' : ''}
                    </span>
                    <span className="tw-text-[#888] tw-block tw-mt-0.5">{addr.street1}, {addr.city}</span>
                  </button>
                );
              })}
            </div>
          )}
          <div className="tw-flex tw-flex-col tw-gap-3">
            <input type="text" placeholder="Full name" value={s.shippingTo}
              onChange={function(e) { self.setState({ shippingTo: e.target.value }); }}
              className={inputClass} style={validStyle(isNameValid)} />
            {!isLoggedIn ? (
              <input type="email" placeholder="Email" value={s.guestEmail}
                onChange={function(e) { self.setState({ guestEmail: e.target.value }); }}
                className={inputClass} style={validStyle(isEmailValid)} />
            ) : null}
            {addressFields}
          </div>
        </div>

        {/* Billing = Shipping checkbox */}
        <div className="tw-flex tw-items-center tw-gap-3 tw-mb-4">
          <input type="checkbox" id="sameAddress" checked={s.sameAddress}
            onChange={function() { self.setState({ sameAddress: !s.sameAddress }); }}
            className="tw-w-5 tw-h-5 tw-flex-shrink-0 tw-accent-brand-gold" />
          <label htmlFor="sameAddress" className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa] tw-mb-0 tw-leading-normal tw-cursor-pointer">Billing address same as shipping</label>
        </div>

        {billingFields}

        {/* Payment Method Toggle */}
        <div className="tw-mb-4">
          <h2 className="tw-text-base tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-3">Payment Method</h2>
          <div className="tw-flex tw-gap-3">
            <button
              type="button"
              onClick={function() { self.setState({ paymentMethod: 'card' }); }}
              className={'tw-flex-1 tw-py-2.5 tw-px-4 tw-rounded-lg tw-text-sm tw-font-medium tw-cursor-pointer tw-transition-colors tw-border ' + (
                s.paymentMethod === 'card'
                  ? 'tw-border-brand-gold tw-bg-brand-gold/10 tw-text-brand-gold'
                  : 'tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-transparent tw-text-[#666] dark:tw-text-gray-400 hover:tw-border-brand-gold'
              )}
            >
              <i className="fa fa-credit-card tw-mr-2" />
              Pay with Card
            </button>
            <button
              type="button"
              onClick={function() { if (hasPaypal) self.setState({ paymentMethod: 'paypal' }); }}
              disabled={!hasPaypal}
              className={'tw-flex-1 tw-py-2.5 tw-px-4 tw-rounded-lg tw-text-sm tw-font-medium tw-transition-colors tw-border ' + (
                !hasPaypal
                  ? 'tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-transparent tw-text-[#ccc] dark:tw-text-[#555] tw-cursor-not-allowed'
                  : s.paymentMethod === 'paypal'
                    ? 'tw-border-brand-gold tw-bg-brand-gold/10 tw-text-brand-gold tw-cursor-pointer'
                    : 'tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-transparent tw-text-[#666] dark:tw-text-gray-400 hover:tw-border-brand-gold tw-cursor-pointer'
              )}
            >
              <i className="fa fa-paypal tw-mr-2" />
              {hasPaypal ? 'Pay with PayPal' : 'PayPal unavailable'}
            </button>
          </div>
        </div>

        {/* Saved Cards + New Card Selection */}
        {s.paymentMethod === 'card' ? (
          <div className="tw-mb-4">
            {/* Loading saved cards */}
            {isLoggedIn && s.loadingCards && (
              <div className="tw-flex tw-items-center tw-gap-2 tw-py-3 tw-mb-3">
                <i className="fa fa-spinner fa-spin tw-text-brand-gold" />
                <span className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400">Loading saved cards...</span>
              </div>
            )}
            {/* Saved card radio options */}
            {isLoggedIn && !s.loadingCards && s.savedCards.length > 0 && (
              <div className="tw-flex tw-flex-col tw-gap-2 tw-mb-3">
                {s.savedCards.map(function(card) {
                  var isSelected = s.selectedCardId === card.id;
                  var brandIcon = BRAND_ICONS[card.brand] || 'fa-credit-card';
                  return (
                    <label
                      key={card.id}
                      className={'tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2.5 tw-rounded-lg tw-cursor-pointer tw-transition-colors tw-border ' + (
                        isSelected
                          ? 'tw-border-brand-gold tw-bg-brand-gold/5'
                          : 'tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-white dark:tw-bg-[#141414] hover:tw-border-brand-gold/50'
                      )}
                    >
                      <input
                        type="radio"
                        name="cardSelection"
                        checked={isSelected}
                        onChange={function() { self.setState({ selectedCardId: card.id }); }}
                        className="tw-w-4 tw-h-4 tw-accent-brand-gold"
                      />
                      <i className={'fa ' + brandIcon + ' tw-text-lg ' + (isSelected ? 'tw-text-brand-gold' : 'tw-text-[#666] dark:tw-text-gray-400')} />
                      <span className={'tw-text-sm tw-font-medium ' + (isSelected ? 'tw-text-[#1a1a1a] dark:tw-text-white' : 'tw-text-[#666] dark:tw-text-gray-400')}>
                        {'····' + card.last4}
                      </span>
                      <span className="tw-text-xs tw-text-[#999] dark:tw-text-gray-500">
                        {card.expMonth + '/' + card.expYear}
                      </span>
                      {card.isDefault && (
                        <span className="tw-text-[10px] tw-font-semibold tw-px-1.5 tw-py-0.5 tw-rounded tw-bg-brand-gold/15 tw-text-brand-gold">Default</span>
                      )}
                    </label>
                  );
                })}
                {/* New card option */}
                <label
                  className={'tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2.5 tw-rounded-lg tw-cursor-pointer tw-transition-colors tw-border ' + (
                    !s.selectedCardId
                      ? 'tw-border-brand-gold tw-bg-brand-gold/5'
                      : 'tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-white dark:tw-bg-[#141414] hover:tw-border-brand-gold/50'
                  )}
                >
                  <input
                    type="radio"
                    name="cardSelection"
                    checked={!s.selectedCardId}
                    onChange={function() { self.setState({ selectedCardId: null }); }}
                    className="tw-w-4 tw-h-4 tw-accent-brand-gold"
                  />
                  <i className={'fa fa-plus-circle tw-text-lg ' + (!s.selectedCardId ? 'tw-text-brand-gold' : 'tw-text-[#666] dark:tw-text-gray-400')} />
                  <span className={'tw-text-sm tw-font-medium ' + (!s.selectedCardId ? 'tw-text-[#1a1a1a] dark:tw-text-white' : 'tw-text-[#666] dark:tw-text-gray-400')}>
                    Use a new card
                  </span>
                </label>
              </div>
            )}

            {/* Stripe Card Elements — show only when new card is selected, cards done loading, and shipping filled */}
            {!usingSavedCard && !s.loadingCards && !this.shippingValid ? (
              <div className="tw-bg-gray-100 dark:tw-bg-[#111] tw-rounded-lg tw-p-4 tw-text-center tw-text-[#888] dark:tw-text-gray-500 tw-text-sm">
                Complete your shipping &amp; contact info to continue to payment.
              </div>
            ) : null}
            {!usingSavedCard && !s.loadingCards && this.shippingValid ? (
              <div className="tw-flex tw-flex-col tw-gap-3">
                <div className="tw-px-4 tw-py-2.5 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#141414]">
                  <CardNumberElement
                    onChange={function(e) { if (e.complete && self._expiryEl) self._expiryEl.focus(); }}
                    style={{ base: { fontSize: '14px', color: document.documentElement.classList.contains('tw-dark') ? '#ffffff' : '#1a1a1a', '::placeholder': { color: document.documentElement.classList.contains('tw-dark') ? '#666' : '#aab7c4' } } }}
                  />
                </div>
                <div className="tw-flex tw-gap-3">
                  <div className="tw-flex-1 tw-px-4 tw-py-2.5 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#141414]">
                    <CardExpiryElement
                      onReady={function(el) { self._expiryEl = el; }}
                      onChange={function(e) { if (e.complete && self._cvcEl) self._cvcEl.focus(); }}
                      style={{ base: { fontSize: '14px', color: document.documentElement.classList.contains('tw-dark') ? '#ffffff' : '#1a1a1a', '::placeholder': { color: document.documentElement.classList.contains('tw-dark') ? '#666' : '#aab7c4' } } }}
                    />
                  </div>
                  <div className="tw-flex-1 tw-px-4 tw-py-2.5 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#141414]">
                    <CardCVCElement
                      onReady={function(el) { self._cvcEl = el; }}
                      style={{ base: { fontSize: '14px', color: document.documentElement.classList.contains('tw-dark') ? '#ffffff' : '#1a1a1a', '::placeholder': { color: document.documentElement.classList.contains('tw-dark') ? '#666' : '#aab7c4' } } }}
                    />
                  </div>
                </div>
                {/* Save card checkbox */}
                {isLoggedIn && (
                  <div className="tw-flex tw-items-center tw-gap-3 tw-mt-1">
                    <input
                      type="checkbox"
                      id="saveNewCard"
                      checked={s.saveNewCard}
                      onChange={function() { self.setState({ saveNewCard: !s.saveNewCard }); }}
                      className="tw-w-5 tw-h-5 tw-flex-shrink-0 tw-accent-brand-gold"
                    />
                    <label htmlFor="saveNewCard" className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0 tw-leading-normal tw-cursor-pointer">
                      Save this card for future purchases
                    </label>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        ) : null}

        {/* Error message */}
        {s.error ? (
          <div className="tw-bg-red-600/10 tw-border tw-border-red-600/30 tw-rounded-lg tw-py-2.5 tw-px-4 tw-mb-4">
            <p className="tw-text-red-500 tw-text-sm tw-mb-0">{s.error}</p>
          </div>
        ) : null}

        {/* Pay button (Stripe) */}
        {s.paymentMethod === 'card' ? (
          <button type="submit" className="tw-w-full tw-py-3 tw-rounded-lg tw-text-sm tw-font-bold tw-border-none tw-transition-colors tw-cursor-pointer tw-bg-brand-gold hover:tw-bg-brand-gold-dark tw-text-black">
            Pay ${total}
          </button>
        ) : null}

        {/* PayPal button container — only rendered when shipping is valid so PayPal SDK finds the container */}
        <div style={{ display: s.paymentMethod === 'paypal' ? 'block' : 'none' }}>
          {this.shippingValid
            ? <div id="paypal-button" className="tw-mt-2"></div>
            : <div className="tw-bg-gray-100 dark:tw-bg-[#111] tw-rounded-lg tw-p-4 tw-text-center tw-text-[#888] dark:tw-text-gray-500 tw-text-sm">
                Complete your shipping &amp; contact info to continue to payment.
              </div>
          }
        </div>
      </form>
    );
  }
}

export default injectStripe(CheckoutForm);
